module.exports = __webpack_public_path__ + "static/media/6.dd33bd24.JPG";